import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import { Toastcontainer5, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'axios';
import moment from 'moment';
import { isMobile } from 'react-device-detect';

const pageingState = {
  gotoPage: 1,
  pageCount: 0,
  con: 0,
};
const CollaboReserveList = (props) => {
  const { loginId, apiUrl, pkg, history, icon, nicName, imgUrl } = props;
  const [payList, setPayList] = useState([]);

  const [page, setPage] = useState(pageingState);

  const _getData = async (gotoPage) => {
    const result = await axios.post(apiUrl + '/collaboReserveList', {
      userid: loginId,
      pkg: pkg,
      gotoPage: gotoPage,
      pageSize: 3,
    });

    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const listData = result.data[0].listData;
    // console.log(result.data[0]);
    if (intReturn === 0) {
      setPayList(listData);
      setPage({
        ...page,
        gotoPage,
        con,
        pageCount,
      });
    } else {
      toast.warn('예약내역이 존재하지 않습니다.');
    }
  };

  const _detail = (orderCode) => {
    history.push(`/cr/${orderCode}`);
  };

  const _reserve = () => {
    history.push('/cr');
  };
  const _onPrev = () => {
    const { gotoPage } = page;
    if (gotoPage === 1) {
      toast.warn('페이지의 처음입니다.');
    } else {
      _getData(gotoPage - 1);
    }
  };
  const _onNext = () => {
    const { gotoPage, pageCount } = page;
    if (gotoPage + 1 > pageCount) {
      toast.warn('페이지의 마지막입니다.');
    } else {
      _getData(gotoPage + 1);
    }
  };
  const _prevEnd = () => {
    _getData(1);
  };
  const _nextEnd = () => {
    const { gotoPage, pageCount } = page;
    _getData(pageCount);
  };
  const _ReanerPage = () => {
    const { gotoPage, con, pageCount } = page;
    const dataPerPage = 3;
    console.log(gotoPage, con, pageCount);
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }
    const list = pageNumbers.map((num, index) => {
      return (
        <li key={index} className={gotoPage === num ? 'active' : null}>
          <a onClick={() => _getData(num)} style={{ cursor: 'pointer' }}>
            {num}
          </a>
        </li>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <>
        <button type="button" className="btn_first" onClick={() => _prevEnd()}>
          맨처음
        </button>
        <button type="button" className="btn_prev" onClick={() => _onPrev()}>
          이전
        </button>
        <ul>{list}</ul>
        <button type="button" className="btn_next" onClick={() => _onNext()}>
          다음
        </button>
        <button type="button" className="btn_last" onClick={() => _nextEnd()}>
          마지막
        </button>
      </>
    );
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  const _back = () => {
    // history.push('/cr');
    history.goBack();
  };

  useEffect(() => {
    if (loginId === null || loginId === undefined || loginId === '') {
      history.push('/login');
    } else {
      _getData(1);
    }
  }, []);

  console.log(payList);

  if (payList.length <= 0) {
    // toast.warn('예매내역이 존재하지 않습니다.');
  }

  return (
    <div id="wrap">
      <a className="close" onClick={_back} style={{ cursor: 'pointer' }}></a>
      {/* <!-- 컨텐츠영역 --> */}
      <section className="container5 tiket3">
        {/* <!-- 왼쪽 컨텐츠 --> */}
        <div className="bx">
          <h1 className="colHeader">
            콜라보 카페 예약 목록
            {/* <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" /> */}
          </h1>
          <div className="profile">
            <div className="profile_img">
              <img src={icon} alt="" />
            </div>
            <div className="name">{nicName}님</div>
            <div className="etc">총 {page.con}건 예약</div>
          </div>

          <div className="section sec_item sec_item2">
            <div className="btn_collabo" onClick={_reserve}>
              <span>콜라보 카페 예약하기</span>
            </div>
          </div>
        </div>
        {/* <!-- 오른쪽 컨텐츠 --> */}
        <div className="bx">
          <div className="section sec_item sec_reserve">
            {payList.length <= 0 && (
              <div className="item">
                <div className="item_top">
                  <span className="day">예약한 내역이 없습니다.</span>
                </div>
              </div>
            )}
            {payList.map((item, index) => {
              return (
                <div
                  className="item"
                  onClick={() => _detail(item.orderCode)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="item_top">
                    <span className="day">
                      결제일
                      <span>{item.regDate}</span>
                    </span>
                    {item.chkTicket === 'Y' && (
                      <a className="bttn bttn_end">입장승인 완료</a>
                    )}
                    {item.cancel && (
                      <a className="bttn bttn_cancel">예약취소 완료</a>
                    )}
                  </div>
                  <div className="item_cont">
                    <div className="thumb">
                      <img
                        src={
                          'https://file.aniplustv.com/TShop/collabo/' +
                          item.colImg
                        }
                        alt=""
                        style={{ borderRadius: '10px' }}
                      />
                    </div>
                    <ul>
                      <li>
                        <span className="tit">작품명</span>
                        <span className="txt">{item.reserveTitle}</span>
                      </li>
                      <li>
                        <span className="tit">장소</span>
                        <span className="txt"> {item.collaboLocationName}</span>
                      </li>
                      <li>
                        <span className="tit">예약날짜</span>
                        <span className="txt">
                          {' '}
                          {moment(
                            item.rdate.toString().substring(0, 4) +
                              '-' +
                              item.rdate.toString().substring(4, 6) +
                              '-' +
                              item.rdate.toString().substring(6, 8)
                          ).format('YYYY.MM.DD(dd)')}
                        </span>
                      </li>
                      <li>
                        <span className="tit">시간</span>
                        <span className="txt">
                          {item.rtime.toString().substring(0, 2) +
                            ':' +
                            item.rtime.toString().substring(2, 4)}
                        </span>
                      </li>
                      <li>
                        <span className="tit">예약수량</span>
                        <span className="txt">{item.rcount}인</span>
                      </li>
                      <li>
                        <span className="tit">결제금액</span>
                        <span className="txt">
                          {CommaFormatted(item.price)}원{' '}
                          {/* {item.early === 'Y' ? ' (얼리버드)' : ''} */}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}

            {/* <div className="item">
              <div className="item_top">
                <span className="day">
                  예매일<span>2023.05.06</span>
                </span>
                <a href="#" className="bttn bttn_end">
                  발권승인 완료
                </a>
              </div>
              <div className="item_cont">
                <div className="thumb">
                  <img src="/img/mediaArt/img_wrap.jpg" alt="" />
                </div>

                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">앙상블 스타즈</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">명동 그라운드 시소</span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">2023.09.20</span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">2회 오후 12시 00분</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">70,000원</span>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
          <div className="paging">
            <_ReanerPage />
          </div>
        </div>
      </section>
    </div>

    // <div className="content">
    //   <div style={{ backgroundColor: "#fff" }}>
    //     <div onClick={_reserve}>예매하기</div>
    //     <div>
    //       {payList.map((item, index) => {
    //         return (
    //           <div>
    //             <span onClick={() => _detail(item.orderCode)}>
    //               {item.rdate}|{item.rtime}|{item.rcount}|{item.price} |{" "}
    //             </span>

    //             {item.chkTicket === "Y" ? (
    //               <span>발권완료</span>
    //             ) : item.cancel === false ? (
    //               <span></span>
    //             ) : (
    //               <span>취소완료</span>
    //             )}
    //           </div>
    //         );
    //       })}
    //     </div>
    //   </div>
    // </div>
  );
};

export default shopContext(withRouter(CollaboReserveList));
